/* src/app/modules/employees/tiempo/components/mapa-geolocalizacion/mapa-geolocalizacion.component.scss */
.mapa-dialog-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 900px;
  min-width: 600px;
  max-height: 80vh;
}
.mapa-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fafafa;
}
.mapa-header h2 {
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}
.mapa-header h2 .header-icon {
  margin-right: 8px;
  color: var(--cf-brand-dark);
}
.mapa-header .close-button {
  color: #666;
}
.mapa-header .close-button:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.04);
}
.mapa-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.mapa-content .info-panel {
  width: 280px;
  background-color: #f8f9fa;
  border-right: 1px solid #e0e0e0;
  padding: 16px;
  overflow-y: auto;
}
.mapa-content .info-panel .info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 12px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.mapa-content .info-panel .info-item:last-child {
  margin-bottom: 0;
}
.mapa-content .info-panel .info-item mat-icon {
  margin-right: 12px;
  margin-top: 2px;
}
.mapa-content .info-panel .info-item mat-icon.icon-inicio {
  color: #4caf50;
}
.mapa-content .info-panel .info-item mat-icon.icon-fin {
  color: #f44336;
}
.mapa-content .info-panel .info-item .info-text {
  flex: 1;
}
.mapa-content .info-panel .info-item .info-text .info-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  font-size: 14px;
}
.mapa-content .info-panel .info-item .info-text .info-desc {
  color: #666;
  font-size: 12px;
  line-height: 1.4;
}
.mapa-content .mapa-container {
  flex: 1;
  position: relative;
  background-color: #f5f5f5;
}
.mapa-content .mapa-container .mapa-element {
  width: 100%;
  height: 100%;
  min-height: 400px;
}
.mapa-content .mapa-container .mapa-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.mapa-content .mapa-container .mapa-loading p {
  margin: 12px 0 0 0;
  color: #666;
  font-size: 14px;
}
.mapa-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
}
.mapa-actions button {
  min-width: 100px;
}
@media (max-width: 768px) {
  .mapa-dialog-container {
    min-width: 100%;
    max-height: 90vh;
  }
  .mapa-content {
    flex-direction: column;
  }
  .mapa-content .info-panel {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
    max-height: 200px;
  }
  .mapa-content .mapa-container .mapa-element {
    min-height: 300px;
  }
}
::ng-deep .mat-mdc-dialog-container {
  padding: 0 !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}
::ng-deep .gm-style .gm-style-iw {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
/*# sourceMappingURL=mapa-geolocalizacion.component.css.map */
